// extracted by mini-css-extract-plugin
export default {"root":"_1XSPP","small":"_2Cmyd","normal":"_5b1jx"};